export const getBonus = (bonus) => {
    // @ts-ignore
    if (bonus.type === 'SAMPLE_BUDGET') {
        return {
            // @ts-ignore
            value: bonus.amount.value,
            // @ts-ignore
            currency: bonus.amount.currency,
        };
    }
    return undefined;
};
